import "./index.scss";
import { ReactComponent as PromoIcon } from '../../../../assets/icons/promo-icon.svg';
import { config } from "../../../../utils/config";
import i18n from "../../../../utils/translations/i18n";
import PromoCouponGreen from "../../../../assets/icons/promo-coupon-green";
import CustomTooltip from "../../elements/customTooltip";
import { get, getBrandKeywordCampaignParameters } from "../../../../utils/cookies";

const PromoCodes = ({ applyCouponHandlerChild }) => {
    const { t } = i18n;
    let customerDiscounts = config('customerDiscounts');
    let specialOfferCookie = getBrandKeywordCampaignParameters(get('np.brandKeywordCampaign')).couponCode;

    // Return early if discounts are invalid or empty
    if (!customerDiscounts || customerDiscounts === '[]') {
        return null;
    }

    try {
        customerDiscounts = JSON.parse(customerDiscounts.replace(/[\n\r]+/g, ''));
    } catch (error) {
        console.error("Invalid customerDiscounts format", error);
        return null;
    }

    const today = new Date();
    const MIN_DATE = new Date(-8640000000000000); // Equivalent to -Infinity for dates
    const MAX_DATE = new Date(8640000000000000);  // Equivalent to +Infinity for dates

    // Filter valid discounts directly and ensure the code exists
    const validDiscounts = customerDiscounts.filter(discount => {
        const validFrom = discount?.validFrom ? new Date(discount.validFrom) : MIN_DATE;
        const validTill = discount?.validTill ? new Date(discount.validTill) : MAX_DATE;

        // Ensure valid date range and check for discount code
        return validFrom <= today && validTill >= today && discount?.code && discount.code !== specialOfferCookie;
    });

    // If no valid discounts exist, return early
    if (validDiscounts.length === 0) {
        return null;
    }

    return (
        <div className='your-promos-section'>
            <span className='your-promos-heading'>{t('order_summary.your_promo_code')}</span>
            {validDiscounts.map((discount, index) => (
                <div key={index} className='customer-discount-container'>
                    <div className='discount-info-container'>
                        <div className='discount-title'>
                            <PromoCouponGreen width={11} height={11} className='promoIcon'/>
                            <span className="promo-title">{discount.code}</span>
                        </div>
                        {discount.description && (
                            <div className='discount-information'>
                                <span className='discount-description'>
                                    {discount.description}&nbsp;
                                    {discount.Details && (
                                        <CustomTooltip content={discount.Details} wrapperClasses="details-tooltip-wrapper" tooltipClasses="details-tooltip"><span className='discount-details link--underline'>{t('order_summary.details')}</span></CustomTooltip>
                                    )}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className='discount-apply-btn'>
                        <div id='applyCoupon' onClick={() => applyCouponHandlerChild(discount.code)}>
                            {t('shopping_cart_details.apply')}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PromoCodes;
